import React, { useRef, useState, useEffect } from "react";

const VideoPlayer = ({ videoObjects, onLog, style }) => {
  const videoRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const loggedEventsRef = useRef(new Set());

  const currentVideo = videoObjects[currentIndex];

  useEffect(() => {
    // Reset logged events when video changes
    loggedEventsRef.current.clear();
  }, [currentIndex]);

  const logOnce = (eventName, url) => {
    const key = `${eventName}:${url}`;
    if (!loggedEventsRef.current.has(key)) {
      loggedEventsRef.current.add(key);
      onLog?.(eventName, url);
    }
  };

  const handlePlay = () => {
    if (!currentVideo) return;

    currentVideo.trackers
      ?.filter((tracker) => tracker.event === 1)
      .forEach((tracker) => {
        fetch(tracker.url).catch(console.error);
        logOnce("event 1", currentVideo.url);
      });
  };

  const handleError = () => {
    currentVideo.trackers
      ?.filter((tracker) => tracker.event === 511)
      .forEach((tracker) => {
        fetch(tracker.url).catch(console.error);
        logOnce("play_error", currentVideo.url);
      });
  };

  const handleEnded = () => {
    logOnce("ended", currentVideo.url);
    setCurrentIndex((prev) => (prev + 1) % videoObjects.length);
  };

  if (!currentVideo) return null;

  return (
    <video
      ref={videoRef}
      src={currentVideo.url}
      onEnded={handleEnded}
      onPlay={handlePlay}
      onError={handleError}
      autoPlay
      muted
      loop={false}
      style={style}
    />
  );
};

export default VideoPlayer;
